import { render, staticRenderFns } from "./logHistory.vue?vue&type=template&id=513cd67a&"
import script from "./logHistory.vue?vue&type=script&lang=js&"
export * from "./logHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports